import '../css/index.less';
import { fillBlanks } from './fillPlaceholders.js';

function shuffleArray(array) {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

function adjustCellFontSize(cellDiv, baseFontSize) {
  let fontSize = baseFontSize;
  cellDiv.style.fontSize = `${fontSize}rem`;
  
  // Check if content overflows
  while ((cellDiv.scrollHeight > cellDiv.clientHeight || cellDiv.scrollWidth > cellDiv.clientWidth) && fontSize > 0.4) {
    fontSize -= 0.05;
    cellDiv.style.fontSize = `${fontSize}rem`;
  }
}

function generateBingoCards(inputs, cardCount) {
  const cards = [];
  for (let n = 0; n < cardCount; n++) {
    const shuffled = shuffleArray(inputs);
    const card = [];
    let index = 0;
    for (let row = 0; row < 5; row++) {
      card[row] = [];
      for (let col = 0; col < 5; col++) {
        if (row === 2 && col === 2) {
          card[row][col] = "FREE";
        } else {
          card[row][col] = shuffled[index++];
        }
      }
    }
    cards.push(card);
  }
  return cards;
}

function createUI() {
  const app = document.getElementById('app');
  app.innerHTML = `
    <div id="sidebar" class="sidebar">
      <button type="button" id="toggle-sidebar" class="toggle-sidebar-btn" title="Close sidebar">×</button>
      <h3>Navigation</h3>
      <a href="#bingo-options" class="sidebar-link sidebar-link-options">Bingo Options</a>
      <div id="sidebar-cards-section"></div>
    </div>
    <button type="button" id="open-sidebar" class="open-sidebar-btn" style="display: none;">☰</button>
    <div id="main-content" class="main-content">
      <h1 class="page-title">Bingo Card Generator</h1>
      <div id="bingo-options">
        <form id="bingo-form">
          <div class="form-row">
            <label>Card Title:
              <input type="text" id="card-title" placeholder="My Bingo Card" maxlength="50" />
            </label>
            <label>Number of Cards:
              <input type="number" id="card-count" value="1" min="1" max="100" />
            </label>
            <label>Bingo Card Font Size (ex: 1.2):
              <input type="number" id="font-size" value="1" min="0.5" max="3" step="0.05" />
            </label>
          </div>
          <div class="button-container">
            <button type="button" id="toggle-inputs">Hide Item Inputs</button>
            <button type="submit">Generate Cards</button>
          </div>
          <div id="inputs" class="grid-input"></div>
        </form>
      </div>
      <div id="cards-output"></div>
    </div>
  `;

  // Sidebar toggle functionality
  const sidebar = document.getElementById('sidebar');
  const toggleSidebarBtn = document.getElementById('toggle-sidebar');
  const openSidebarBtn = document.getElementById('open-sidebar');

  sidebar.classList.add('sidebar-hidden');
  openSidebarBtn.style.display = 'block';

  toggleSidebarBtn.addEventListener('click', () => {
    sidebar.classList.add('sidebar-hidden');
    openSidebarBtn.style.display = 'block';
  });

  openSidebarBtn.addEventListener('click', () => {
    sidebar.classList.remove('sidebar-hidden');
    openSidebarBtn.style.display = 'none';
  });

  const toggleBtn = document.getElementById('toggle-inputs');
  toggleBtn.addEventListener('click', () => {
    const inputsDiv = document.getElementById('inputs');
    const isHidden = inputsDiv.style.display === 'none';
    inputsDiv.style.display = isHidden ? 'grid' : 'none';
    toggleBtn.textContent = isHidden ? 'Hide Item Inputs' : 'Show Item Inputs';
  });

  const fontSizeInput = document.getElementById('font-size');
  fontSizeInput.addEventListener('input', () => {
    const value = parseFloat(fontSizeInput.value);
    if (value > 3) {
      fontSizeInput.value = 3;
    } else if (value < 0.5) {
      fontSizeInput.value = 0.5;
    }
  });
  fontSizeInput.addEventListener('blur', () => {
    // Regenerate cards if any exist
    const cardsOutput = document.getElementById('cards-output');
    if (cardsOutput.children.length > 0) {
      document.getElementById('bingo-form').dispatchEvent(new Event('submit'));
    }
  });

  const cardCountInput = document.getElementById('card-count');
  cardCountInput.addEventListener('focus', () => {
    setTimeout(() => {
      cardCountInput.select();
    }, 0);
  });


  const inputsDiv = document.getElementById('inputs');
  for (let i = 0; i < 24; i++) {
    const input = document.createElement('input');
    input.type = 'text';
    input.placeholder = `Item ${i + 1}`;
    input.name = 'item';
    input.addEventListener('input', () => {
      if (input.value.length > 128) {
        input.value = input.value.slice(0, 128);
      }

    });
    input.addEventListener('focus', () => {
      input.select();
    });


    inputsDiv.appendChild(input);
  }

  document.getElementById('bingo-form').addEventListener('submit', e => {
    e.preventDefault();

    let inputs = Array.from(inputsDiv.querySelectorAll('input')).map(i => i.value.trim());
    inputs = fillBlanks(inputs);

    const cardCount = parseInt(document.getElementById('card-count').value);
    const fontSize = parseFloat(document.getElementById('font-size').value) || 1;
    const cards = generateBingoCards(inputs, cardCount);

    const output = document.getElementById('cards-output');
    output.innerHTML = '';
    const sidebarCardsSection = document.getElementById('sidebar-cards-section');
    sidebarCardsSection.innerHTML = '';

    const cardsHeading = document.createElement('h4');
    cardsHeading.textContent = 'Cards';
    cardsHeading.style.marginTop = '1.5rem';
    cardsHeading.style.marginBottom = '0.5rem';
    cardsHeading.style.fontSize = '0.9rem';
    cardsHeading.style.color = '#777';
    cardsHeading.style.textTransform = 'uppercase';
    cardsHeading.style.fontWeight = '600';
    sidebarCardsSection.appendChild(cardsHeading);

    cards.forEach((card, i) => {
      const cardContainer = document.createElement('div');
      cardContainer.className = 'card';
      cardContainer.id = `card-${i + 1}`;
      const title = document.getElementById('card-title').value.trim() || `Card ${i + 1}`;
      const titleHeading = document.createElement('h3');
      titleHeading.textContent = `${title}`;
      cardContainer.appendChild(titleHeading);

      // Add sidebar link
      const sidebarLink = document.createElement('a');
      sidebarLink.href = `#card-${i + 1}`;
      sidebarLink.textContent = `Card ${i + 1}`;
      sidebarLink.className = 'sidebar-link';
      sidebarCardsSection.appendChild(sidebarLink);
      // Create card grid
      const grid = document.createElement('div');
      grid.className = 'card-grid';

      card.flat().forEach(cell => {
        const cellDiv = document.createElement('div');
        cellDiv.className = 'cell';
        cellDiv.textContent = cell;
        cellDiv.style.fontSize = `${fontSize}rem`;
        grid.appendChild(cellDiv);
      });

      // Adjust font sizes after cells are rendered
      requestAnimationFrame(() => {
        grid.querySelectorAll('.cell').forEach(cellDiv => {
          adjustCellFontSize(cellDiv, fontSize);
        });
      });

      const printBtn = document.createElement('button');
      printBtn.textContent = 'Print this card';
      printBtn.className = 'card-print-btn';
      printBtn.addEventListener('click', () => {
        const clone = cardContainer.cloneNode(true);

        const printWindow = window.open('', '_blank');
        printWindow.document.write(`
          <html>
            <head>
              <title>Bingo Card</title>
              <style>
                <style>
                  @page {
                    size: 8.5in 11in;
                    margin: 1in;
                  }

                  body {
                    font-family: sans-serif;
                    margin: 0;
                    padding: 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 100vh;
                  }

                  .card {
                    width: 100%;
                    max-width: 7.5in;
                    aspect-ratio: 1 / 1;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    padding: 1rem;
                    box-sizing: border-box;
                    page-break-inside: avoid;
                  }

                  .card h3 {
                    margin-top: 0;
                    margin-bottom: 1rem;
                    font-size: 1.25rem;
                  }

                  .card-grid {
                    display: grid;
                    grid-template-columns: repeat(5, 1fr);
                    gap: 0.25rem;
                    width: 100%;
                    height: 100%;
                  }

                  .cell {
                    border: 1px solid #333;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: bold;
                    font-size: ${fontSize}rem;
                    padding: 0.5rem;
                    aspect-ratio: 1 / 1;
                    text-align: center;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }

                  button {
                    display: none;
                  }
              </style>
            </head>
            <body></body>
          </html>
        `);

        printWindow.document.body.appendChild(clone);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      });



      cardContainer.appendChild(grid);
      cardContainer.appendChild(printBtn);
      output.appendChild(cardContainer);
    });
  });
}

document.addEventListener('DOMContentLoaded', createUI);
